import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Typography } from 'antd';
import { FacebookOutlined, RobotOutlined } from '@ant-design/icons';
import { pagesService } from '../services/pages.service';
import { autoPostService } from '../services/autopost.service';
import { useAuth } from '../context/AuthContext';

const { Title } = Typography;

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    pages: 0,
    rules: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const pages = await pagesService.getAll();
        const rules = await autoPostService.getAll();
        setStats({ pages: pages.length, rules: rules.length });
      } catch (error) {
        console.error(error);
      }
    };
    fetchStats();
  }, [user]);

  return (
    <div>
      <Title level={2}>Bảng điều khiển</Title>
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Trang đang quản lý"
              value={stats.pages}
              prefix={<FacebookOutlined style={{ color: '#1890ff' }} />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Quy tắc đăng tự động"
              value={stats.rules}
              prefix={<RobotOutlined style={{ color: '#52c41a' }} />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Trạng thái hệ thống"
              value="Đang hoạt động"
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
      </Row>
      
      <div style={{ marginTop: 40 }}>
        <Title level={4}>Chào mừng bạn đến với Hệ thống quản lý Facebook</Title>
        <p>Sử dụng thanh bên để quản lý các trang, tạo bài viết hoặc cấu hình các quy tắc tự động hóa của bạn.</p>
      </div>
    </div>
  );
};

export default Dashboard;
